import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/ActionList/ActionList.docs.json';
import { ActionList, Avatar } from '@primer/react';
import { LinkIcon, AlertIcon, ArrowRightIcon } from '@primer/octicons-react';
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Box = makeShortcode("Box");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <DeprecationBanner replacementUrl={'/components/action-list/react/latest'} mdxType="DeprecationBanner" />
    <Box sx={{
      border: '1px solid',
      borderColor: 'border.default',
      borderRadius: 2,
      padding: 6,
      marginBottom: 3
    }} mdxType="Box">
  <ActionList sx={{
        width: 320
      }} mdxType="ActionList">
    <ActionList.Item>
      <ActionList.LeadingVisual>
        <LinkIcon mdxType="LinkIcon" />
      </ActionList.LeadingVisual>
      github.com/primer
      <ActionList.Description variant="block">
        A React implementation of GitHub's Primer Design System
      </ActionList.Description>
    </ActionList.Item>
    <ActionList.Item>
      <ActionList.LeadingVisual>
        <Avatar src="https://github.com/mona.png" mdxType="Avatar" />
      </ActionList.LeadingVisual>
      mona
      <ActionList.Description>Monalisa Octocat</ActionList.Description>
    </ActionList.Item>
    <ActionList.Item variant="danger">
      <ActionList.LeadingVisual>
        <AlertIcon mdxType="AlertIcon" />
      </ActionList.LeadingVisual>
      4 vulnerabilities
      <ActionList.TrailingVisual>
        <ArrowRightIcon mdxType="ArrowRightIcon" />
      </ActionList.TrailingVisual>
    </ActionList.Item>
  </ActionList>
    </Box>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {ActionList} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Minimal example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ActionList>
  <ActionList.Item>New file</ActionList.Item>
  <ActionList.Item>Copy link</ActionList.Item>
  <ActionList.Item>Edit file</ActionList.Item>
  <ActionList.Divider />
  <ActionList.Item variant="danger">Delete file</ActionList.Item>
</ActionList>
`}</code></pre>
    <h3>{`With leading visual`}</h3>
    <p>{`Leading visuals are optional and appear at the start of an item. They can be octicons, avatars, and other custom visuals that fit a small area.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ActionList>
  <ActionList.Item>
    <ActionList.LeadingVisual>
      <LinkIcon />
    </ActionList.LeadingVisual>
    github.com/primer
  </ActionList.Item>
  <ActionList.Item variant="danger">
    <ActionList.LeadingVisual>
      <AlertIcon />
    </ActionList.LeadingVisual>
    4 vulnerabilities
  </ActionList.Item>
  <ActionList.Item>
    <ActionList.LeadingVisual>
      <Avatar src="https://github.com/mona.png" />
    </ActionList.LeadingVisual>
    mona
  </ActionList.Item>
</ActionList>
`}</code></pre>
    <h3>{`With trailing visual`}</h3>
    <p>{`Trailing visual and trailing text can display auxiliary information. They're placed at the right of the item, and can denote status, keyboard shortcuts, or be used to set expectations about what the action does.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ActionList>
  <ActionList.Item>
    New file
    <ActionList.TrailingVisual>⌘ + N</ActionList.TrailingVisual>
  </ActionList.Item>
  <ActionList.Item>
    Copy link
    <ActionList.TrailingVisual>⌘ + C</ActionList.TrailingVisual>
  </ActionList.Item>
  <ActionList.Item>
    Edit file
    <ActionList.TrailingVisual>⌘ + E</ActionList.TrailingVisual>
  </ActionList.Item>
  <ActionList.Item variant="danger">
    Delete file
    <ActionList.TrailingVisual>⌫</ActionList.TrailingVisual>
  </ActionList.Item>
</ActionList>
`}</code></pre>
    <h3>{`With description and dividers`}</h3>
    <p>{`Item dividers allow users to parse heavier amounts of information. They're placed between items and are useful in complex lists, particularly when descriptions or multi-line text is present.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ActionList showDividers>
  <ActionList.Item>
    <ActionList.LeadingVisual>
      <Avatar src="https://github.com/mona.png" />
    </ActionList.LeadingVisual>
    mona
    <ActionList.Description>Monalisa Octocat</ActionList.Description>
  </ActionList.Item>
  <ActionList.Item>
    <ActionList.LeadingVisual>
      <Avatar src="https://github.com/hubot.png" />
    </ActionList.LeadingVisual>
    hubot
    <ActionList.Description>Hubot</ActionList.Description>
  </ActionList.Item>
  <ActionList.Item>
    <ActionList.LeadingVisual>
      <Avatar src="https://github.com/primer-css.png" />
    </ActionList.LeadingVisual>
    primer-css
    <ActionList.Description>GitHub Design Systems Bot</ActionList.Description>
  </ActionList.Item>
</ActionList>
`}</code></pre>
    <h3>{`With links`}</h3>
    <p>{`When you want to add links to the List instead of actions, use `}<inlineCode parentName="p">{`ActionList.LinkItem`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<ActionList>
  <ActionList.LinkItem href="https://github.com/primer">
    <ActionList.LeadingVisual>
      <LinkIcon />
    </ActionList.LeadingVisual>
    github/primer
  </ActionList.LinkItem>
  <ActionList.LinkItem as={ReactRouterLink} to="/">
    <ActionList.LeadingVisual>
      <LawIcon />
    </ActionList.LeadingVisual>
    MIT License
  </ActionList.LinkItem>
  <ActionList.LinkItem href="https://github.com/primer/react/stargazers" target="_blank" rel="noopener noreferrer">
    <ActionList.LeadingVisual>
      <StarIcon />
    </ActionList.LeadingVisual>
    1.4k stars
  </ActionList.LinkItem>
</ActionList>
`}</code></pre>
    <h3>{`With groups`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const SelectFields = () => {
  const [options, setOptions] = React.useState([
    {text: 'Status', selected: true},
    {text: 'Stage', selected: true},
    {text: 'Assignee', selected: true},
    {text: 'Team', selected: true},
    {text: 'Estimate', selected: false},
    {text: 'Due Date', selected: false},
  ])

  const visibleOptions = options.filter(option => option.selected)
  const hiddenOptions = options.filter(option => !option.selected)

  const toggle = text => {
    setOptions(
      options.map(option => {
        if (option.text === text) option.selected = !option.selected
        return option
      }),
    )
  }

  return (
    <ActionList selectionVariant="multiple">
      <ActionList.Group>
        <ActionList.GroupHeading>Visible fields</ActionList.GroupHeading>
        {visibleOptions.map(option => (
          <ActionList.Item key={option.text} selected={true} onSelect={() => toggle(option.text)}>
            {option.text}
          </ActionList.Item>
        ))}
      </ActionList.Group>
      <ActionList.Group
        selectionVariant={
          /** selectionVariant override on Group: disable selection if there are no options */
          hiddenOptions.length ? 'multiple' : false
        }
      >
        <ActionList.GroupHeading>Hidden fields</ActionList.GroupHeading>
        {hiddenOptions.map((option, index) => (
          <ActionList.Item key={option.text} selected={false} onSelect={() => toggle(option.text)}>
            {option.text}
          </ActionList.Item>
        ))}
        {hiddenOptions.length === 0 && <ActionList.Item disabled>No hidden fields</ActionList.Item>}
      </ActionList.Group>
    </ActionList>
  )
}

render(<SelectFields />)
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: true,
      a11yReviewed: true,
      stableApi: false,
      // TODO: revisit on April 10, 2022
      addressedApiFeedback: false,
      hasDesignGuidelines: true,
      hasFigmaComponent: true
    }} mdxType="ComponentChecklist" />
    <h2>{`Further reading`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://primer.style/design/components/action-list"
        }}>{`Interface guidelines: Action List`}</a></li>
    </ul>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/ActionMenu"
        }}>{`ActionMenu`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/SelectPanel"
        }}>{`SelectPanel`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      